<template>
    <svg class="svg-container">
        <defs>
            <marker id="goto-arrow" markerWidth="8" markerHeight="8" refX="8" refY="4" orient="auto" markerUnits="strokeWidth">
                <path d="M0,0 L8,4 L0,8 Z" fill="#ff9800" />
            </marker>
        </defs>
        <path v-for="path in connectors()" :d="path.path" :key="path.id" />
        <path
            v-for="path in connectors().filter((x) => isSelected(x.id))"
            :d="path.path"
            :key="path.id + '-selected'"
            class="selected"
        />
        <circle v-if="gotoPreviewGeom" :cx="gotoPreviewGeom.startX" :cy="gotoPreviewGeom.startY" r="4" class="goto-preview-start" />
        <path v-if="gotoPreviewGeom" :d="gotoPreviewGeom.path" class="goto-preview" marker-end="url(#goto-arrow)" />
    </svg>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../utils/log2";

const log = log2("BlockConnectors");
export default {
    name: "BlockConnectors",
    props: ["blocks", "metas", "testState", "testStartBlockId", "gotoPreview"],
    methods: {
        calculateConnector(parent, i) {
            const isLast = i === this.blocks.length - 1;
            if (isLast && parent.type === "FLOW") return [];
            const sourceMeta = this.metas[parent.id];
            // log("sourceMeta", sourceMeta);
            const sourceX = sourceMeta.x;
            const sourceY = sourceMeta.y;
            const sourceWidth = sourceMeta.width;
            const sourceHeight = sourceMeta.height;
            const childCount = parent.children.length;
            const isOddBlockLength = childCount % 2 === 1;
            const middleIndex = (childCount - 1) / 2.0;
            return parent.children
                .map((child, i) => {
                    const targetMeta = this.metas[child.id];
                    if (!targetMeta) return null;
                    const targetX = targetMeta.x;
                    const targetY = targetMeta.y;
                    const targetWidth = targetMeta.width;
                    const targetHeight = targetMeta.height;
                    const isMiddleBlock = childCount === 1 || (isOddBlockLength && i === middleIndex);
                    const isCurved = isMiddleBlock ? false : childCount > 1;

                    let path = "";
                    if (isCurved) {
                        const moveX = sourceX + sourceWidth + 5;
                        const moveY = sourceY + sourceHeight / 2;
                        const cX1 = sourceX + sourceWidth + 50;
                        const cY1 = sourceY + sourceHeight / 2;
                        const cX2 = targetX - 60;
                        const cY2 = targetY + targetHeight / 2;
                        const endX = targetX - (targetMeta.isSquare ? 15 : 0);
                        const endY = targetY + targetHeight / 2;
                        path = `M${moveX} ${moveY} C ${cX1} ${cY1} ${cX2} ${cY2} ${endX} ${endY}`;
                    } else {
                        path = `M${sourceX + sourceWidth + (sourceMeta.isSquare ? 15 : 10)} ${
                            sourceY + sourceHeight / 2
                        } L ${targetX - (targetMeta.isSquare ? 15 : 10)} ${targetY + targetHeight / 2}`;
                    }
                    return {
                        path,
                        id: child.id,
                    };
                })
                .filter(Boolean);
        },
        connectors() {
            const connectors = _.flatten(this.blocks.map((block, i) => this.calculateConnector(block, i)));
            // log("connectors", connectors);
            return connectors;
        },
        isSelected(blockId) {
            if (this.testStartBlockId === blockId) return false;
            const isClosed = _.get(this.testState, "closed", true);
            const selectedPaths = isClosed ? [] : _.get(this.testState, "history", []);
            // log("isSelected", { selectedPaths, blockId, result: selectedPaths.includes(blockId) });
            return selectedPaths.includes(blockId);
        },
    },
    computed: {
        gotoPreviewGeom() {
            try {
                if (!this.gotoPreview) return null;
                const fromMeta = this.metas[this.gotoPreview.fromId];
                const toMeta = this.metas[this.gotoPreview.toId];
                if (!fromMeta || !toMeta) return null;
                const startX = fromMeta.x + fromMeta.width / 2;
                const startY = fromMeta.y - 8;
                const targetTopX = toMeta.x + toMeta.width / 2;
                const targetTopY = toMeta.y - 2;
                const targetBottomX = toMeta.x + toMeta.width / 2;
                const targetBottomY = toMeta.y + toMeta.height + 2;
                const goingDown = startY <= toMeta.y;
                const endX = goingDown ? targetTopX : targetBottomX;
                const endY = goingDown ? targetTopY : targetBottomY;
                const dy = endY - startY;
                const dx = endX - startX;
                const midY = startY + dy / 2;
                const midX = (startX + endX) / 2;
                const dist = Math.sqrt(dx * dx + dy * dy);
                const offset = Math.max(100, Math.min(260, dist * 0.40));
                const dir = dy >= 0 ? 1 : -1;
                const c1x = startX + offset * 1.2;
                const c1y = startY + dir * offset * 0.35;
                const c2x = midX - offset * 0.9;
                const c2y = midY - dir * offset * 0.55;
                const c3x = midX + offset * 0.9;
                const c3y = midY + dir * offset * 0.55;
                const c4x = endX - offset * 1.2;
                const c4y = endY - dir * offset * 0.35;
                const path = `M${startX} ${startY} C ${c1x} ${c1y} ${c2x} ${c2y} ${midX} ${midY} C ${c3x} ${c3y} ${c4x} ${c4y} ${endX} ${endY}`;
                return { path, startX, startY, endX, endY };
            } catch (e) {
                return null;
            }
        },
    },
    mounted() {
        log("mounted", {
            blocks: this.blocks,
            metas: this.metas,
        });
    },
    watch: {
        blocks: function () {
            // log("blocks", {
            //     blocks: this.blocks,
            //     metas: this.metas,
            // });
        },
        metas: function () {
            // log("metas", {
            //     blocks: this.blocks,
            //     metas: this.metas,
            // });
        },
    },
};
</script>

<style lang="scss">
.svg-container {
    overflow: visible !important;
    pointer-events: none;
    position: absolute;

    path {
        fill: none;
        stroke-width: 2.5px;
        stroke: #c9d3de;
        transition: all 0.7s;
        animation-duration: 3s;
    }

    path.selected {
        stroke: #006cff;
        animation-name: lineanim;
        animation-timing-function: ease-in;
    }

    path.goto-preview {
        stroke: #ff9800;
        stroke-dasharray: 6 4;
        animation: none;
    }

    .goto-preview-start {
        fill: #ff9800;
        stroke: #ff9800;
    }

    @keyframes lineanim {
        0% {
            stroke-dashoffset: 1000;
            stroke-dasharray: 1000;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }
}
</style>
